import { render } from "./AboutMeComponent.vue?vue&type=template&id=57ce354c"
import script from "./AboutMeComponent.vue?vue&type=script&lang=js"
export * from "./AboutMeComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\WORK\\tft prod\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__